import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CarViewModel, getBuildIdQuery, IFilterItemViewModel } from '@ncg/data';
import { StorageService } from '../../core/storage.service';
import { FavoritesService } from '../favorites.service';

@Component({
    selector: 'ncg-favorite-button',
    template: `
        <ng-container *ngIf="storageService.isStorageSupported">
            <!-- ngFor just lets us save isFavorite as a variable in our template -->
            <button
                *ngFor="let isFavorite of [favoriteService.favorites$ | async | isFavorite: item.id || '']; trackBy: trackByFn"
                class="favorite-button"
                type="button"
                (click)="toggleFavorite($event, item, isFavorite)"
                [ngClass]="{
                    'favorite-button--is-favorite': isFavorite,
                    'favorite-button--touched': isTouched
                }"
                [attr.title]="'favorites.toggle_' + (isFavorite ? 'remove' : 'add') | translate"
            >
                <svg-icon-sprite
                    [src]="'assets/images/sprite.svg' + buildIdQuery + '#heart'"
                    [viewBox]="'0 0 30 30'"
                    [width]="'100%'"
                    [height]="'100%'"
                    aria-hidden="true"
                    class="favorite-button__icon"
                ></svg-icon-sprite>
                <svg-icon-sprite
                    [src]="'assets/images/sprite.svg' + buildIdQuery + '#heart_solid'"
                    [viewBox]="'0 0 30 30'"
                    [width]="'100%'"
                    [height]="'100%'"
                    aria-hidden="true"
                    class="favorite-button__icon favorite-button__icon--solid"
                ></svg-icon-sprite>
            </button>
        </ng-container>
    `,
    styleUrls: ['./favorite-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FavoriteButtonComponent {
    public buildIdQuery = getBuildIdQuery();

    @Input() item: IFilterItemViewModel | CarViewModel;
    public isTouched = false;

    constructor(
        public readonly favoriteService: FavoritesService,
        public readonly storageService: StorageService
    ) {}

    public toggleFavorite(e: Event, item: IFilterItemViewModel | CarViewModel, isFavorite: boolean): void {
        const { id, make, model, series, bodyTypes } = item;
        if (!id) {
            return;
        }
        this.isTouched = true;
        // Because we sadly might be inside a link, we have to do this
        e.preventDefault();
        e.stopPropagation();
        isFavorite ? this.favoriteService.remove(id) : this.favoriteService.add({ id, make, model, series, bodyTypes });
    }

    public trackByFn(index: number, item: any) {
        return item.id || index;
    }
}
